import { render, staticRenderFns } from "./HmiReguladores2.vue?vue&type=template&id=a4fd9832&lang=true"
import script from "./HmiReguladores2.vue?vue&type=script&lang=js"
export * from "./HmiReguladores2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports